import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import { DateFormaterMonth } from "../../Components/GlobalFunctions";
import { ContentLoader } from "../../Components/Shimmer";
import "./PreviewStatus.css"

const PreviewStatus = () => {
    const { apiURL, apiHeaderJson } = useContext(ConfigContext);
    const { project_request_id } = useParams();
    const [selectOption, setSelectOption] = useState(null);
    const [loadingList, setLoadingList] = useState(false);
    const [consultantInfo, setConsultantInfo] = useState([]);
    const [attachments, setAttachments] = useState([])
    const [requestedInfo, setRequestedInfo] = useState({});
    const navigate = useNavigate()
    const [errors, setErrors] = useState({})
    const naviagte = useNavigate()

    const handleSelectStatus = (selectedOption) => {
        setSelectOption(selectedOption ? selectedOption.value : "");
    };

    const GetInfo = async () => {
        try {
            setLoadingList(true)
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/requests/GetProjectRequestInfo?project_request_id=${project_request_id}`, {
                headers,
            })
            const { data, success } = response.data;
            if (success) {
                setRequestedInfo(data.info)
                setConsultantInfo(data.consultants)
                setAttachments(data.attachments)
                setLoadingList(false)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingList(false)
        }
    };

    useEffect(() => {
        project_request_id && GetInfo()
    }, [project_request_id]);

    return (
        <>
            {
                loadingList ? <ContentLoader /> :
                    <>

                        <div className="center-form-wrapper">
                            <div className="vi-container shadow-none">
                                <div className="vi-preview shadow-none printable-area">
                                    <div className="row justify-content-center">
                                        <div className="col-12 col-lg-10">
                                            <div className="card" id="demo">
                                                <div className="row">

                                                    <div className="col-lg-12">
                                                        <div className="card-body p-4 pb-0 pt-0">
                                                            <div className="vi-participant-section d-flex flex-wrap justify-content-between align-items-start">
                                                                <div className="vi-logo mb-3 mb-md-0">
                                                                    <img
                                                                        src="/assets/images/new_logo.png"
                                                                        alt="Company Logo"
                                                                        onError={(e) => { e.target.style.display = 'none'; }}
                                                                        className="img-fluid"
                                                                        style={{ maxHeight: "60px" }}
                                                                    />
                                                                </div>

                                                                <div className='vi-participant me-md-5'>
                                                                    <p className="mb-0">{requestedInfo?.project_title}</p>
                                                                    <h6 className="text-muted">Project</h6>
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <div className="row mb-1" >
                                                                                <div className="col-6"><p className="mb-0">{DateFormaterMonth(requestedInfo?.project_start_date)}</p></div>
                                                                                <div className="col-6"><p className="mb-0">{DateFormaterMonth(requestedInfo?.project_end_date)}</p></div>
                                                                                <div className="col-6 text-muted">Start Date</div>
                                                                                <div className="col-6 text-muted">End Date</div>
                                                                            </div>
                                                                            <div className="row mb-1" >
                                                                                <div className="col-12"><p className="mb-0">{requestedInfo?.project_address}</p></div>
                                                                                <div className="col-12 text-muted">Location </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="vi-participant mt-3 mt-md-0">
                                                                    <p className="mb-0">{requestedInfo?.profile_name}</p>
                                                                    <h6 className="text-muted">Contractor</h6>
                                                                    <p className="mb-0"> {DateFormaterMonth(requestedInfo?.request_date)}</p>
                                                                    <h6 className="text-muted">Request Date</h6>
                                                                </div>
                                                            </div>

                                                            <div className="header">
                                                                <div className="row mb-1 mt-2 mb-2" >
                                                                    <div className="col-md-3 fw-bold">Ref. # : {(requestedInfo?.project_request_id)}</div>
                                                                    <div className="col-md-3">Rev # : {(requestedInfo?.request_revision_count)}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12">
                                                        <div className="card-body p-4 pt-0">
                                                            <div className="table-responsive">
                                                                <table className="table table-borderless text-center table-nowrap align-middle mb-0">
                                                                    <thead>
                                                                        <tr className="table-active">
                                                                            <th scope="col" style={{ width: 50 }}>
                                                                                {`Sr.No`}
                                                                            </th>
                                                                            <th scope="col">{'Item Name'}</th>
                                                                            <th scope="col">{'Quantity'}</th>
                                                                            <th scope="col">{'Price'}</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody id="products-list">
                                                                        <tr>
                                                                            <th scope="row">1</th>
                                                                            <td>{requestedInfo?.item_name}</td>
                                                                            <td>{requestedInfo?.pi_item_qty}</td>
                                                                            <td>{requestedInfo?.pi_item_price}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            <div className="row mb-3 mt-4">
                                                                <div className="col-md-6">
                                                                    <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                                        {'Type Of Submittal'}
                                                                    </p>
                                                                    <h5 className="fs-14 mb-0">
                                                                        {requestedInfo?.submittal_description}
                                                                    </h5>
                                                                </div>
                                                            </div>

                                                            <div className="row mb-3">
                                                                <div className="col-md-6 mb-3 mb-md-0">
                                                                    <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                                        {'Breif Description'}
                                                                    </p>
                                                                    <h5 className="fs-14 mb-0 text-justify">
                                                                        {requestedInfo?.request_brief_description}
                                                                    </h5>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="text-muted mb-2 text-uppercase fw-semibold">Digital Sign</label>
                                                                    <div className="signature-container">
                                                                        <img
                                                                            className="img-fluid signature-image"
                                                                            src={`${apiURL}api/profile-signature/${requestedInfo.digital_signature}`}
                                                                            alt="Signature"
                                                                            onError={(e) => {
                                                                                e.target.style.display = 'none';
                                                                                e.target.parentElement.innerHTML = '<p class="text-muted mb-0">No Signature Available</p>';
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row mb-3">
                                                                <div className="col-md-6">
                                                                    <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                                        {'Submitted By (Name):'}
                                                                    </p>
                                                                    <h5 className="fs-14 mb-0">
                                                                        {requestedInfo?.profile_name}
                                                                    </h5>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                                        {'Position'}
                                                                    </p>
                                                                    <h5 className="fs-14 mb-0">
                                                                        {requestedInfo?.profile_about ?? "-"}
                                                                    </h5>
                                                                </div>
                                                            </div>

                                                            <div className="row mb-3">
                                                                <div className="col-md-12">
                                                                    <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                                        {'Consultant Revision'}
                                                                    </p>
                                                                    <h5 className="fs-14 mb-0 text-justify">
                                                                        {requestedInfo?.request_revision_remark ?? "-"}
                                                                    </h5>
                                                                </div>
                                                            </div>

                                                            <div className="vi-actions no-print mt-4">
                                                                <button
                                                                    className="btn btn-success float-end"
                                                                    onClick={() => window.print()}
                                                                >
                                                                    Print <i className="ri-printer-line ms-2" />
                                                                </button>

                                                                <button
                                                                    className="btn btn-info float-end me-2 mb-4"
                                                                    onClick={() => navigate(-1)}
                                                                >
                                                                    Go Back <i className="ri-arrow-go-back-line ms-2" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }
        </>
    );
};

export default PreviewStatus;